module.exports = __webpack_public_path__ + "img/03.93544764.png";